// extracted by mini-css-extract-plugin
export default {"initial-state":"EmptyStatus_initial-state__XHa7S"};